// UCES flag group owned by the automation engine, which enforces the same
// limits on save; see flags.yml in automation_engine.
export const AUTOMATION_ENGINE_FLAG_GROUP = "automation_engine";

// Flag names within the group; must match the engine's flags.yml.
export const CONDITIONAL_LOGIC_FLAG = "conditional_logic";
export const NESTED_LOOPS_FLAG = "nested_loops";
export const MAX_ACTIONS_PER_AUTOMATION_FLAG = "max_actions_per_automation";
export const MAX_AUTOMATIONS_PER_SOLUTION_FLAG = "max_automations_per_solution";
export const MAX_TRIGGER_CONDITIONS_FLAG = "max_trigger_conditions";
export const MAX_CHECKLIST_ITEMS_FLAG = "max_checklist_items";
export const MAX_CONDITIONS_BRANCHES_FLAG = "max_conditions_branches";
export const MIN_TOTAL_BRANCHES_FLAG = "min_total_branches";
export const MAX_ADVANCED_LOGIC_DEPTH_FLAG = "max_advanced_logic_depth";
